import { put, call, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import client from '../client';
import { appsActions } from '../reducers/apps';
import { ListResponse } from '../models/common';
import { AppListState, AppState } from '../models/apps';
import {
  LoadAppDetailsAction,
  UpdateAppDetailsAction,
  CreateAppAction,
  DeleteAppAction,
} from '../actionTypes/apps';

export function* loadAppList() {
  try {
    const response: ListResponse<AppListState> = yield call(client, {
      url: `app/list`,
    });
    yield put(appsActions.loadAppListSuccess(response));
  } catch (error: any) {
    yield put(appsActions.loadAppListFail(error));
  }
}

export function* loadAppDetails({ payload: { id, res, rej } }: PayloadAction<LoadAppDetailsAction>) {
  try {
    const response: ListResponse<AppState> = yield call(client, {
      url: `app/${id}`,
    });
    yield put(appsActions.loadAppDetailsSuccess(response));

    if (typeof res === 'function') {
      yield call(res, response);
    }
  } catch (error: any) {
    yield put(appsActions.loadAppDetailsFail(error));

    if (typeof rej === 'function') {
      yield call(rej, error);
    }
  }
}

export function* updateAppDetails({ payload: { appId, data, res, rej } }: PayloadAction<UpdateAppDetailsAction>) {

  try {
    const response: ListResponse<AppState> = yield call(client, {
      url: `app/update/${appId}`,
      method: 'post',
      data,
    });
    yield put(appsActions.updateAppDetailsSuccess(response));
    if (typeof res === 'function') {
      yield call(res, response);
    }
  } catch (error: any) {
    yield put(appsActions.updateAppDetailsFail(error));
    if (typeof rej === 'function') {
      yield call(rej, error);
    }
  }
}

export function* createApp({ payload: { data, res, rej } }: PayloadAction<CreateAppAction>) {
  try {
    const response: ListResponse<AppState> = yield call(client, {
      url: `app/create`,
      method: 'post',
      data,
    });
    yield put(appsActions.createAppSuccess(response));
    if (typeof res === 'function') {
      yield call(res, response);
    }
  } catch (err: any) {
    yield put(appsActions.createAppFail(err));
    if (typeof rej === 'function') {
      yield call(rej, err);
    }
  }
}

export function* deleteApp({ payload: { appId, res, rej } }: PayloadAction<DeleteAppAction>) {
  try {
    const response = yield call(client, {
      url: `app/delete/${appId}`,
      method: 'post',
    });
    yield put(appsActions.deleteAppSuccess());
    if (typeof res === 'function') {
      yield call(res, response);
    }
  } catch (error: any) {
    yield put(appsActions.deleteAppFail(error));
    if (typeof rej === 'function') {
      yield call(rej, error);
    }
  }
}

export function* regenerateSecret({ payload: { appId, res, rej } }: PayloadAction<DeleteAppAction>) {
  try {
    const response = yield call(client, {
      url: `app/regenerateSecret/${appId}`,
      method: 'post',
    });
    yield put(appsActions.regenerateSecretSuccess(response));
    if (typeof res === 'function') {
      yield call(res, response);
    }
  } catch (err) {
    yield put(appsActions.regenerateSecretFail(err));
    if (typeof rej === 'function') {
      yield call(rej, err);
    }
  }
}

export default function* permissionSaga() {
  yield takeLatest(appsActions.loadAppList.type, loadAppList);
  yield takeLatest(appsActions.loadAppDetails.type, loadAppDetails);
  yield takeLatest(appsActions.updateAppDetails.type, updateAppDetails);
  yield takeLatest(appsActions.createApp.type, createApp);
  yield takeLatest(appsActions.deleteApp.type, deleteApp);
  yield takeLatest(appsActions.regenerateSecret.type, regenerateSecret);
}
